import React from 'react'
import { createRoot } from 'react-dom/client'
import { HotspotEditor } from './HotspotEditor'
import { HotspotViewer } from './HotspotViewer'

/** Mounted by HotspotQuestion.EditorWidget in assessment/questions/hotspot.py. */
export const startHotspotEditor = (el, props) => {
  createRoot(el).render(<HotspotEditor mountEl={el} {...props} />)
}

/** Mounted by the instructor canvas and grading templates for hotspot questions. */
export const startHotspotViewer = (el, props) => {
  createRoot(el).render(<HotspotViewer {...props} />)
}
